function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  viewBox: "0 0 24 24",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M11 16.15v2.7C11 21.1 10.1 22 7.85 22h-2.7C2.9 22 2 21.1 2 18.85v-2.7C2 13.9 2.9 13 5.15 13h2.7c2.25 0 3.15.9 3.15 3.15z"
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M16.48 2C19.53 2 22 4.47 22 7.52v7.96c0 3.46-2.07 5.52-5.52 5.52H13.5c-.55 0-1-.45-1-1v-4.5c0-2.21-1.79-4-4-4H4c-.55 0-1-.45-1-1V7.52C3 4.47 5.47 2 8.52 2h7.96zm1.532 3.22c.19 0 .38.07.53.22.29.29.29.77 0 1.06l-3.74 3.75h2.21a.749.749 0 110 1.5h-4.01a.742.742 0 01-.685-.449.736.736 0 01-.065-.301V6.99c0-.42.34-.76.75-.76s.75.34.75.75v2.204l3.73-3.744c.15-.15.34-.22.53-.22z"
})));